export enum PortalClassesEnum {
    Header = "Header",
    NavBar = "NavBar",
    NavItem = "NavItem",
    Button = "Button",
    EditButton = "Edit",
    Text = "Text",
    TextArea = "TextArea",
    Checkbox = "Checkbox",
    Card = "Card",
    FormField = "FormField",
    Input = "Input",
    CardInput = "CardInput",
    Link = "Link",
    Alert = "Alert",
    Select = "Select",
    Badge = "Badge",
    Menu = "Menu",
    Modal = "Modal",
    RadioButton = "Radio",
    StateContainer = "StateContainer",
    MenuItem = "MenuItem",
    Slider = "Slider",
    Drawer = "Drawer",
    Pill = "Pill",
    Box = "Box",
    MessageBox = "MessageBox",
    Tab = "Tab",
    Breadcrumb = "Breadcrumb",
    Image = "Image",
    IconButton = "IconButton",
    MarkingPortal = "MarkingPortal",
    AccordionItem = "AccordionItem",
    UserInfoContainer = "UserInfoContainer",
    AgeGroupContainer = "AgeGroupContainer",
    GradeCurriculumContainer = "GradeCurriculumContainer",
    MembershipContainer = "MembershipContainer",
    PremiumServiceContainer = "PremiumServiceContainer",
    InternationalPremiumServicesContainer = "InternationalPremiumServicesContainer",
    PaymentDetailsContainer = "PaymentDetailsContainer",
    CardDetailsContainer = "CardDetailsContainer",
    StudentSelectionContainer = "StudentSelectionContainer",
    CreateNewStudentContainer = "CreateNewStudentContainer",
    CheckoutContainer = "CheckoutContainer",
    ExistingUserContainer = "ExistingUserContainer",
    GradeContainer = "GradeContainer",
    PathwayContainer = "PathwayContainer",
    PaymentSuccessContainer = "PaymentSuccessContainer",
    ChangePasswordContainer = "ChangePasswordContainer",
    DashboardContainer = "DashboardContainer",
    InitiateEnrolmentContainer = "InitiateEnrolmentContainer",
    ManageProgramsContainer = "ManageProgramsContainer",
    ManageStudentContainer = "ManageStudentContainer",
    StudentDocsContainer = "StudentDocsContainer",
    SharedAccessContainer = "SharedAccessContainer",
    AccountSetupContainer = "AccountSetupContainer",
    AccountDetailsContainer = "AccountDetailsContainer",
    EmailPreferencesContainer = "EmailPreferencesContainer",
    BillingInfoContainer = "BillingInfoContainer",
    AccountSuccessContainer = "AccountSuccessContainer",
    CreatePasswordContainer = "CreatePasswordContainer",
    CreateStudentContainer = "CreateStudentContainer",
    EnrolmentInfoContainer = "EnrolmentInfoContainer",
    EnrolmentSuccessContainer = "EnrolmentSuccessContainer",
    SelectProgramContainer = "SelectProgramContainer",
    StudentPerformanceContainer = "StudentPerformanceContainer",
    LoginContainer = "LoginContainer",
    SubjectEvaluationContainer = "SubjectEvaluationContainer",
    BillingAddressContainer = "BillingAddressContainer",
    SubmittedForReviewContainer = "SubmittedForReviewContainer",
    ReviewRegistrationContainer = "ReviewRegistrationContainer",
    SubjectSelectionContainer = "SubjectSelectionContainer",
    FooterInfo = "FooterInfo",
    ExternalCourseManager = "ExternalCourseManager",
    BrowseElectivesContainer = "BrowseElectivesContainer",
    SelectElectivesContainer = "SelectElectivesContainer",
    ElectiveIntroContainer = "ElectiveIntroContainer",
    ElectiveRecommendationContainer = "ElectiveRecommendationContainer",
    LocationSelectDrawer = "LocationSelectDrawer",
    Option = "Option",
    InitialRegistrationContainer = "InitialRegistrationContainer",
    BeginRegistrationContainer = "BeginRegistrationContainer",
    ManageRegistrationServiceContainer = "ManageRegistrationServiceContainer",
    RegistrationStepsContainer = "RegistrationStepsContainer",
    RegistrationDetailContainer = "RegistrationDetailContainer",
    IEPDownloadDisclaimerModal = "IEPDownloadDisclaimerModal",
    ReportsContainer = "ReportsContainer",
    ManageElectivesContainer = "ManageElectivesContainer",
    ManageSubjectsContainer = "ManageSubjectsContainer",
    SubscriptionCTA = "SubscriptionCTA",
    AssignmentDetailsContainer = "AssignmentDetailsContainer",
    ManageReportingContainer = "ManageReportingContainer",
    FileUploader = "FileUploader",
    DeliverableUrlInput = "DeliverableUrlInput",
    MarkedSubmissions = "MarkedSubmissions",
    CompletionCertificate = "CompletionCertificate",
    GradeDetailsContainer = "GradeDetailsContainer",
    GradeTermDetailsContainer = "GradeTermDetailsContainer",
    ResultsDetailsPanel = "ResultsDetailsPanel",
    QuizPanel = "QuizPanel",
    Tag = "Tag",
    ExpiredContainer = "ExpiredContainer",
    ForgotPasswordContainer = "ForgotPasswordContainer",
    ResetPasswordContainer = "ResetPasswordContainer",
    ResetPasswordSuccessContainer = "ResetPasswordSuccessContainer",
    ForgotEukaIdContainer = "ForgotEukaIdContainer",
    NotificationContainer = "NotificationContainer",
    ProgramAccessExpireModal = "ProgramAccessExpireModal",
    AlertBanner = "AlertBanner",
    Banner = "Banner",
    DownloadButton = "DownloadButton",
    Logo = "Logo",
    MainNav = "MainNav",
    HeaderBreadcrumb = "HeaderBreadcrumb",
    CustomDrawer = "CustomDrawer",
    ElectiveCard = "ElectiveCard",
    EnrolNav = "EnrolNav",
    IconActionCard = "IconActionCard",
    ButtonGroup = "ButtonGroup",
    GradeOverviewModal = "GradeOverviewModal",
    MobileNav = "MobileNav",
    ParentsNav = "ParentsNav",
    ParentsPortalNav = "ParentsPortalNav",
    ProfileMenuItem = "ProfileMenuItem",
    ProgressCircleStrap = "ProgressCircleStrap",
    Calendar = "Calendar",
    Collapsable = "Collapsable",
    TabButton = "TabButton",
    Tooltip = "Tooltip",
    AssessmentContainer = "AssessmentContainer",
    AssessmentControl = "AssessmentControl",
    AssessmentIntro = "AssessmentIntro",
    AssessmentResult = "AssessmentResult",
    AssessmentsListContainer = "AssessmentsListContainer",
    ResultOverviewContainer = "ResultOverviewContainer",
    RequestOnboardingContainer = "RequestOnboardingContainer",
    EmptySubjectsContainer = "EmptySubjectsContainer",
    LegacyNotificationContainer = "LegacyNotificationContainer",
    CancellationSuccessModal = "CancellationSuccessModal",
    ServiceModal = "ServiceModal",
    ActivityAndAnswerModal = "ActivityAndAnswerModal",
    BillingAndPaymentsSection = "BillingAndPaymentsSection",
    GradeDetailAccordion = "GradeDetailAccordion",
    PremiumGateModal = "PremiumGateModal",
    ScopeAndSequenceList = "ScopeAndSequenceList",
    ManageSubjectsView = "ManageSubjectsView",
    ProgramRenewalContainer = "ProgramRenewalContainer",
    StudentsLocationsContainer = "StudentsLocationsContainer",
    SubjectSelectionSuccessContainer = "SubjectSelectionSuccessContainer",
    AcademicTranscriptPreviewContainer = "AcademicTranscriptPreviewContainer",
    DownloadTranscriptModal = "DownloadTranscriptModal",
    WorkSampleErrorCard = "WorkSampleErrorCard",
    CourseListModal = "CourseListModal",
    ReportingErrorView = "ReportingErrorView",
    SubjectSelectionPrompt = "SubjectSelectionPrompt",
    GradeReportContainer = "GradeReportContainer",
    GradeDownloadTranscriptModal = "GradeDownloadTranscriptModal",
    HomeschoolingOverviewCard = "HomeschoolingOverviewCard",
    HomeschoolingOverviewPremiumCard = "HomeschoolingOverviewPremiumCard",
    LearningPlanModal = "LearningPlanModal",
    LessonsModal = "LessonsModal",
    WorkSampleModal = "WorkSampleModal",
    AcademicTranscriptModal = "AcademicTranscriptModal",
    NonTermSubjectsDetailsContainer = "NonTermSubjectsDetailsContainer",
    AddExemptionModal = "AddExemptionModal",
    ExemptionLimitExceedModal = "ExemptionLimitExceedModal",
    RemoveExemptionModal = "RemoveExemptionModal",
    ScopeAndSequenceCards = "ScopeAndSequenceCards",
    InfoSection = "InfoSection",
    NotFoundPage = "NotFoundPage",
    ActivitySheetSignedUrlExpiredPage = "ActivitySheetSignedUrlExpiredPage",
    ServerErrorPage = "ServerErrorPage",
    WelcomePage = "WelcomePage",
    AssessmentNav = "AssessmentNav",
    CloseButton = "CloseButton",
    ActivitySheetDownloadPage = "ActivitySheetDownloadPage",
    CancelProgramModal = "CancelProgramModal",
    CancelProgramAutoRenewalModal = "CancelProgramAutoRenewalModal",
    CancelProgramBlockedModal = "CancelProgramBlockedModal",
    CancelServiceModal = "CancelServiceModal",
    CancelPremiumServiceBlockedModal = "CancelPremiumServiceBlockedModal",
    CancelAutoRenewalModal = "CancelAutoRenewalModal",
    CancelAutoRenewalSuccessModal = "CancelAutoRenewalSuccessModal",
    ContactSupportToCancelModal = "ContactSupportToCancelModal",
    CancelServiceSuccessModal = "CancelServiceSuccessModal",
    RequestSetSuccessModal = "RequestSetSuccessModal",
    StudentCard = "StudentCard",
    DummyStudentCard = "DummyStudentCard",
    ActivityAndAnswerSheetsModal = "ActivityAndAnswerSheetsModal",
    PremiumServiceAccordion = "PremiumServiceAccordion",
    MatificConnectModal = "MatificConnectModal",
    ManageProfileModal = "ManageProfileModal",
    ManageSubjectCard = "ManageSubjectCard",
    Table = "Table",
    SubjectOverallFeedbackSummaryModal = "SubjectOverallFeedbackSummaryModal",
    CertificateAccessModal = "CertificateAccessModal",
    ManageAchievementModal = "ManageAchievementModal",
    GradeOverallFeedbackModal = "GradeOverallFeedbackModal",
    OverallFeedbackModal = "OverallFeedbackModal",
    SubjectFeedbackModal = "SubjectFeedbackModal",
    SubjectFeedbackNonTermModal = "SubjectFeedbackNonTermModal",
    PlpSupportContent = "PlpSupportContent",
    ContentOverview = "ContentOverview",
    RestoreSubjectConfirmContent = "RestoreSubjectConfirmContent",
    PlpManagementSuccessModal = "PlpManagementSuccessModal"
}
